module.exports = __webpack_public_path__ + "1a1bcb23fbf9eec56ceb8b48511ba595.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-2.svg
// module id = 466
// module chunks = 0